export default __webpack_public_path__ + "static/media/7a.dc2cc158.png";